import { db } from "app/init";
import { differenceInSeconds } from "date-fns";
import moment from "moment";
import {
  collection,
  getDocs,
  addDoc,
  doc,
  getDoc,
  updateDoc,
  deleteDoc,
  where,
  query,
  orderBy,
  limit,
  startAfter,
  startAt,
  getCountFromServer,
  getFirestore,
  setDoc,
  endAt,
} from "firebase/firestore";
import { toast } from "react-toastify";

export const convertHexToRGB = (hex) => {
  // check if it's a rgba
  if (hex.match("rgba")) {
    let triplet = hex.slice(5).split(",").slice(0, -1).join(",");
    return triplet;
  }

  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = "0x" + c.join("");

    return [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",");
  }
};

function currentYPosition(elm) {
  if (!window && !elm) return;

  if (elm) return elm.scrollTop;
  // Firefox, Chrome, Opera, Safari
  if (window.pageYOffset) return window.pageYOffset;
  // Internet Explorer 6 - standards mode
  if (document.documentElement && document.documentElement.scrollTop)
    return document.documentElement.scrollTop;
  // Internet Explorer 6, 7 and 8
  if (document.body.scrollTop) return document.body.scrollTop;
  return 0;
}

function elmYPosition(elm) {
  var y = elm.offsetTop;
  var node = elm;
  while (node.offsetParent && node.offsetParent !== document.body) {
    node = node.offsetParent;
    y += node.offsetTop;
  }
  return y;
}

export function scrollTo(scrollableElement, elmID) {
  var elm = document.getElementById(elmID);

  if (!elmID || !elm) {
    return;
  }

  var startY = currentYPosition(scrollableElement);
  var stopY = elmYPosition(elm);

  var distance = stopY > startY ? stopY - startY : startY - stopY;
  if (distance < 100) {
    scrollTo(0, stopY);
    return;
  }
  var speed = Math.round(distance / 50);
  if (speed >= 20) speed = 20;
  var step = Math.round(distance / 25);
  var leapY = stopY > startY ? startY + step : startY - step;
  var timer = 0;
  if (stopY > startY) {
    for (var i = startY; i < stopY; i += step) {
      setTimeout(
        (function (leapY) {
          return () => {
            scrollableElement.scrollTo(0, leapY);
          };
        })(leapY),
        timer * speed
      );
      leapY += step;
      if (leapY > stopY) leapY = stopY;
      timer++;
    }
    return;
  }
  for (let i = startY; i > stopY; i -= step) {
    setTimeout(
      (function (leapY) {
        return () => {
          scrollableElement.scrollTo(0, leapY);
        };
      })(leapY),
      timer * speed
    );
    leapY -= step;
    if (leapY < stopY) leapY = stopY;
    timer++;
  }
  return false;
}

export function getTimeDifference(date) {
  let difference = differenceInSeconds(new Date(), date);

  if (difference < 60) return `${Math.floor(difference)} sec`;
  else if (difference < 3600) return `${Math.floor(difference / 60)} min`;
  else if (difference < 86400) return `${Math.floor(difference / 3660)} h`;
  else if (difference < 86400 * 30) return `${Math.floor(difference / 86400)} d`;
  else if (difference < 86400 * 30 * 12) return `${Math.floor(difference / 86400 / 30)} mon`;
  else return `${(difference / 86400 / 30 / 12).toFixed(1)} y`;
}

export const getDocDataFilter = async (path, key, value) => {
  const queryData = await query(collection(db, path), where(key, "==", value));
  const querySnapshot = await getDocs(queryData);
  const data = querySnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data()
  }));
  return data;
};

export const getDocData = async (path) => {
  const querySnapshot = await getDocs(collection(db, path));
  const data = querySnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data()
  }));
  return data;
};

export const addDocument = async (db, collectionName, payload) => {
  try {
    const clients = collection(db, collectionName);
    console.log("collectionName::", collectionName);
    console.log("payload::", payload);
    console.log("clients::", clients);
    const data = { lastUpdate: moment().format(), ...payload };
    const response = await addDoc(clients, data);
    console.log("response", response)
    return response;
  } catch (err) {
    console.log("err add::", err);
  }
};

export const updateDocument = async (key, docId, values) => {
  try {
    const docRef = doc(db, key, docId);
    const docSnap = await getDoc(docRef);
    // console.log(docSnap)
    if (!docSnap.exists()) {
      console.log("Document does not exist:", docId);
      return false;
    }

    // console.log("docSnap", docSnap);
    // console.log("docRef", docRef);
    await updateDoc(docRef, {
      ...values,
      lastUpdate: moment().format()
    });
    return true;
  } catch (e) {
    console.error("Error updating document: ", e);
  }
};

export const deleteDocument = async (collectionName, docId) => {
  try {
    const docRef = doc(db, collectionName, docId);
    await deleteDoc(docRef);
    return true;
  } catch (e) {
    console.error("Error updating document: ", e);
  }
};

export const deleteDuplicateBlogs = async (slug) => {
  try {
    const blogsRef = collection(db, "meta-dev"); // Your collection name
    const q = query(blogsRef, where("slug", "==", slug)); // Change "slug" to a unique field

    const querySnapshot = await getDocs(q);
    querySnapshot.forEach(async (docSnap) => {
      await deleteDoc(doc(db, "meta-dev", docSnap.id));
      // console.log(`Deleted document with ID: ${docSnap.id}`);
    });

    // console.log("All duplicate documents deleted!");
  } catch (error) {
    console.error("Error deleting duplicate documents:", error);
  }
};

export const fetchBlogManually = async (collectionName, id) => {
  const db = getFirestore(); // Ensure Firestore is initialized
  const docRef = doc(db, collectionName, id); // Replace with an actual ID
  const docSnap = await getDoc(docRef);
  // console.log("docSnap::", docSnap);

  if (docSnap.exists()) {
    // console.log("Document data:", docSnap.data());
  } else {
    console.log("Document not found");
  }
};

export const getDocDetails = async (collectionName, id, date) => {
  try {
    console.log(`Document with ID ${id} in collection ${collectionName} wiht ${date}`);

    if (!collectionName || !id) {
      throw new Error("Collection name and ID are required");
    }

    const docRef = await doc(db, collectionName, id);
    // console.log("Fetching docRef:", docRef);

    const docSnap = await getDoc(docRef);
    // console.log("Fetched docSnap:", docSnap);

    if (docSnap.exists()) {
      // console.log("Document data:", docSnap.data());
      return docSnap.data();
    } else {
      console.warn(`Document with ID ${id} not found in collection ${collectionName}`);
      return null; // Return `null` explicitly instead of `undefined`
    }
  } catch (error) {
    console.error("Error fetching document:", error);
    return null; // Return `null` to prevent breaking code that expects an object
  }
};

export const checkIfDocumentExists = async (collectionName, id) => {
  const q = query(collection(db, collectionName), where("id", "==", id));
  const querySnapshot = await getDocs(q);

  if (!querySnapshot.empty) {
    // console.log("Document found:", querySnapshot.docs[0].data());
    return querySnapshot.docs[0].data();
  } else {
    console.log("No document found with ID:", id);
    return null;
  }
};

export const mergeDocument = async (key, docId, values) => {
  try {
    const docRef = doc(db, key, docId);
    await setDoc(
      docRef,
      {
        ...values,
        lastUpdate: moment().format()
      },
      { merge: true }
    );

    return true;
  } catch (e) {
    console.error("Error updating document: ", e);
  }
};

export const fetchDataLists = async (
  itemsPerPage,
  cursor = null,
  collectionName,
  orderByKey,
  whereClause = null
) => {
  try {
    if (!db) {
      console.error("Firestore DB is not initialized.");
      return { tasks: [], lastDoc: null, totalCount: 0 };
    }

    if (!collectionName) {
      console.error("Collection name is not provided.");
      return { tasks: [], lastDoc: null, totalCount: 0 };
    }

    const constraints = [orderBy(orderByKey, "desc"), limit(itemsPerPage)];
    if (cursor) constraints.push(startAfter(cursor));
    // console.log("whereClause:", whereClause);
    if (whereClause) {
      if (whereClause.value === "all") {
        // console.log("Skipping 'where' as value is 'all'");
      } else if (typeof whereClause.value !== "undefined") {
        constraints.push(where(whereClause.key, "==", whereClause.value));
      }
    }
    let filteredCount = 0;
    // Calculate filtered count if filters are applied
    if (whereClause && whereClause.value !== "all") {
      const filteredCountQuery = query(
        collection(db, collectionName),
        where(whereClause.key, "==", whereClause.value)
      );
      const filteredCountSnapShot = await getCountFromServer(filteredCountQuery);
      filteredCount = filteredCountSnapShot.data().count;
    }

    const totalCountSnapShot = await getCountFromServer(query(collection(db, collectionName)));
    const totalCount =
      whereClause && whereClause.value !== "all"
        ? filteredCount // Use filtered count if filters are applied
        : totalCountSnapShot.data().count;

    const tasksQuery = await query(collection(db, collectionName), ...constraints);
    const querySnapshot = await getDocs(tasksQuery);

    const tasks = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data()
    }));
    const lastDoc = querySnapshot.docs[querySnapshot.docs.length - 1] || null;
    return { tasks, lastDoc, totalCount: totalCount };
  } catch (error) {
    console.error("Error fetching tasks:", error);
    return { tasks: [], lastDoc: null, totalCount: 0 };
  }
};

export const fetchDataLists2 = async (
  itemsPerPage,
  cursor = null,
  collectionName,
  orderByKey,
  filter = null,
  whereClause = null
) => {
  // console.log("itemsPerPage", itemsPerPage)
  // console.log("whereClause", whereClause)
  // console.log("orderByKey", orderByKey)
  // console.log("collectionName", collectionName)
  // console.log("cursor", cursor)
  // console.log("filter", filter)
  try {
    //  Ensure Firestore is initialized
    if (!db) {
      console.error("Firestore DB is not initialized.");
      return { tasks: [], lastDoc: null, totalCount: 0 };
    }

    //  Ensure Collection Name is Provided
    if (!collectionName) {
      console.error("Collection name is not provided.");
      return { tasks: [], lastDoc: null, totalCount: 0 };
    }

    // Setup Query Constraints
    const constraints = [orderBy(orderByKey, "desc"), limit(itemsPerPage)];
    if (cursor) constraints.push(startAfter(cursor));
    if (itemsPerPage && itemsPerPage > 0) constraints.push(limit(itemsPerPage))
    // Apply Filtering if Needed
    if (whereClause && whereClause.value !== "all") {
      if (whereClause.key === "title") {
        constraints.push(orderBy(whereClause.key)); // Required for startAt()
        constraints.push(startAt(whereClause.value));
        constraints.push(endAt(whereClause.value + "\uf8ff"));
      } else {
        constraints.push(where(whereClause.key, "==", whereClause.value));
      }
    }

    // Apply Status Filter if Provided
    if (filter && filter.value !== "all") {
      constraints.push(where(filter.key, "==", filter.value));
    }

    // Get Filtered Count (when any filter applied)
    let filteredCount = 0;
    if ((whereClause && whereClause.value !== "all") || (filter && filter.value !== "all")) {
      const filteredCountQuery = query(
        collection(db, collectionName),
        ...(whereClause && whereClause.value !== "all"
          ? [where(whereClause.key, "==", whereClause.value)]
          : []),
        ...(filter && filter.value !== "all" ? [where(filter.key, "==", filter.value)] : [])
      );
      const filteredCountSnapShot = await getCountFromServer(filteredCountQuery);
      filteredCount = filteredCountSnapShot.data().count;
    }

    // Get Total Count of Collection (without any filter)
    const totalCountSnapShot = await getCountFromServer(query(collection(db, collectionName)));
    const totalCount =
      (whereClause && whereClause.value !== "all") || (filter && filter.value !== "all")
        ? filteredCount
        : totalCountSnapShot.data().count;

    // Firestore Query Execution
    const tasksQuery = query(collection(db, collectionName), ...constraints);
    const querySnapshot = await getDocs(tasksQuery);

    // Handle Empty Results
    if (querySnapshot.empty) {
      console.warn("No documents found.");
    }

    // Process Results
    const tasks = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data()
    }));

    return {
      tasks,
      lastDoc: querySnapshot.docs[querySnapshot.docs.length - 1] || null,
      totalCount
    };
  } catch (error) {
    // Handle Firestore Errors
    if (error.code === "failed-precondition" || error.code === "permission-denied") {
      console.error("Firestore permission issue:", error.message);
    } else {
      console.error("Error fetching tasks:", error);
    }
    return { tasks: [], lastDoc: null, totalCount: 0 };
  }
};

export const fetchDataLists4 = async (
  itemsPerPage,
  cursor = null,
  collectionName,
  orderByKey,
  whereClause = null,
  filter = null
) => {

  try {
    const userRole = localStorage.getItem("role");

    if (!db) {
      console.error("Firestore DB is not initialized.");
      return { tasks: [], lastDoc: null, totalCount: 0 };
    }

    if (!collectionName) {
      console.error("Collection name is not provided.");
      return { tasks: [], lastDoc: null, totalCount: 0 };
    }

    // Setup query constraints
    const constraints = [orderBy(orderByKey, "desc"), limit(itemsPerPage)];
    if (cursor) constraints.push(startAfter(cursor));
    if (itemsPerPage && itemsPerPage > 0) constraints.push(limit(itemsPerPage));

    // Apply title/field search filter if provided
    if (whereClause && whereClause.value !== "all") {
      if (whereClause.key === "title") {
        constraints.push(orderBy(whereClause.key));
        constraints.push(startAt(whereClause.value));
        constraints.push(endAt(whereClause.value + "\uf8ff"));
      } else {
        constraints.push(where(whereClause.key, "==", whereClause.value));
      }
    }

    // Inject role-based filter
    if (userRole === "SALES") {
      constraints.push(where("status", "==", true));
    } else if (userRole === "HR") {
      constraints.push(where("status", "==", false));
    }

    // Optional additional filtering if passed in
    if (filter && filter.value !== "all") {
      constraints.push(where(filter.key, "==", filter.value));
    }

    // Get filtered count (for UI count purposes)
    let filteredCount = 0;
    if ((whereClause && whereClause.value !== "all") || userRole !== "ADMIN") {
      const countFilters = [];

      if (whereClause && whereClause.value !== "all") {
        countFilters.push(where(whereClause.key, "==", whereClause.value));
      }

      if (userRole === "SALES") {
        countFilters.push(where("status", "==", true));
      } else if (userRole === "HR") {
        countFilters.push(where("status", "==", false));
      }

      const filteredCountQuery = query(collection(db, collectionName), ...countFilters);
      const filteredCountSnapShot = await getCountFromServer(filteredCountQuery);
      filteredCount = filteredCountSnapShot.data().count;
    }

    const totalCountSnapShot = await getCountFromServer(query(collection(db, collectionName)));
    const totalCount =
      (whereClause && whereClause.value !== "all") || userRole !== "ADMIN"
        ? filteredCount
        : totalCountSnapShot.data().count;

    const tasksQuery = query(collection(db, collectionName), ...constraints);
    const querySnapshot = await getDocs(tasksQuery);

    const tasks = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data()
    }));

    return {
      tasks,
      lastDoc: querySnapshot.docs[querySnapshot.docs.length - 1] || null,
      totalCount
    };
  } catch (error) {
    console.error("Error fetching tasks:", error);
    return { tasks: [], lastDoc: null, totalCount: 0 };
  }
};

export const fetchDataLists3 = async (
  itemsPerPage,
  cursor = null,
  collectionName,
  orderByKey,
  whereClause = null
) => {
  // console.log(whereClause)
  try {
    //  Ensure Firestore is initialized
    if (!db) {
      console.error("Firestore DB is not initialized.");
      return { tasks: [], lastDoc: null, totalCount: 0 };
    }

    //  Ensure Collection Name is Provided
    if (!collectionName) {
      console.error("Collection name is not provided.");
      return { tasks: [], lastDoc: null, totalCount: 0 };
    }

    //  Setup Query Constraints
    const constraints = [limit(itemsPerPage)];
    // console.log(constraints)
    if (cursor) constraints.push(startAfter(cursor));

    // console.log("Applying Filters:", whereClause);

    //  Apply Filtering if Needed
    if (whereClause && whereClause.value !== "all") {
      // if (whereClause.key === "title") {
      // Partial search: Firestore allows searching for words that start with `whereClause.value`
      constraints.push(orderBy(whereClause.key)); // Must order by key to use startAt()
      constraints.push(startAt(whereClause.value));
      constraints.push(endAt(whereClause.value + "\uf8ff")); // Get results matching the prefix
      // } else {
      //   constraints.push(where(whereClause.key, "==", whereClause.value));
      // }
    }

    //  Get Filtered Count (Only if a filter is applied)
    let filteredCount = 0;
    if (whereClause && whereClause.value !== "all") {
      const filteredCountQuery = query(
        collection(db, collectionName),
        where(whereClause.key, "==", whereClause.value)
      );
      const filteredCountSnapShot = await getCountFromServer(filteredCountQuery);
      filteredCount = filteredCountSnapShot.data().count;
    }

    //  Get Total Count of Documents in Collection
    const totalCountSnapShot = await getCountFromServer(query(collection(db, collectionName)));
    const totalCount =
      whereClause && whereClause.value !== "all" ? filteredCount : totalCountSnapShot.data().count;
    //  Firestore Query Execution
    const tasksQuery = query(collection(db, collectionName), ...constraints);
    const querySnapshot = await getDocs(tasksQuery);

    //  Handle Empty Results
    if (querySnapshot.empty) {
      console.warn("No documents found.");
    }

    //  Process Results
    const tasks = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data()
    }));


    return {
      tasks,
      lastDoc: querySnapshot.docs[querySnapshot.docs.length - 1] || null,
      totalCount
    };
  } catch (error) {
    //  Handle Firestore Indexing Error
    if (error.code === "failed-precondition" || error.code === "permission-denied") {
      console.error("Firestore permission issue:", error.message);
    } else if (error.code === "permission-denied") {
      console.error("Firestore access denied. Check your Firestore rules.");
    } else {
      console.error("Error fetching tasks:", error);
    }
    return { tasks: [], lastDoc: null, totalCount: 0 };
  }
};


export const fetchReferaldata = async (
  itemsPerPage,
  cursor = null,
  collectionName,
  orderByKey,
  whereClause = null
) => {
  // console.log(orderByKey)
  try {
    if (!db) {
      console.error("Firestore DB is not initialized.");
      return { tasks: [], lastDoc: null, totalCount: 0 };
    }

    if (!collectionName) {
      console.error("Collection name is not provided.");
      return { tasks: [], lastDoc: null, totalCount: 0 };
    }

    const constraints = [
      where("utm_source", ">", ""),
      orderBy("utm_source"),
      orderBy(orderByKey, "desc"),
      limit(itemsPerPage)
    ];

    if (cursor) constraints.push(startAfter(cursor));

    if (whereClause && whereClause.value !== "all") {
      constraints.push(orderBy(whereClause.key));
      constraints.push(startAt(whereClause.value));
      constraints.push(endAt(whereClause.value + "\uf8ff"));
    }

    let filteredCount = 0;
    if (whereClause && whereClause.value !== "all") {
      const filteredCountQuery = query(
        collection(db, collectionName),
        where(whereClause.key, "==", whereClause.value)
      );
      const filteredCountSnapShot = await getCountFromServer(filteredCountQuery);
      filteredCount = filteredCountSnapShot.data().count;
    }

    //  Get Total Count of Documents in Collection
    const totalCountSnapShot = await getCountFromServer(
      query(collection(db, collectionName), where("utm_source", ">", ""))
    );
    const totalCount = totalCountSnapShot.data().count;

    //  Firestore Query Execution
    const tasksQuery = query(collection(db, collectionName), ...constraints);
    const querySnapshot = await getDocs(tasksQuery);

    //  Handle Empty Results
    if (querySnapshot.empty) {
      console.warn("No documents found.");
    }

    //  Process Results
    const tasks = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data()
    }));


    return {
      tasks,
      lastDoc: querySnapshot.docs[querySnapshot.docs.length - 1] || null,
      totalCount
    };
  } catch (error) {
    //  Handle Firestore Indexing Error
    if (error.code === "failed-precondition" || error.code === "permission-denied") {
      console.error("Firestore permission issue:", error.message);
    } else if (error.code === "permission-denied") {
      console.error("Firestore access denied. Check your Firestore rules.");
    } else {
      console.error("Error fetching tasks:", error);
    }
    return { tasks: [], lastDoc: null, totalCount: 0 };
  }
};



export const getNavigationByRole = (role, navigations) => {
  return navigations.filter((items) => {
    if (!items.userRole) return true;
    return items.userRole.includes(role)
  })
}

export const addReferals = async (db, collectionName, payload) => {
  try {
    const refDoc = doc(db, collectionName, payload?.referealId)
    const existingDoc = await getDoc(refDoc);

    if (existingDoc.exists()) {
      throw new Error("Referral with this ID already exists.");
    }

    const clients = collection(db, collectionName);

    const data = { lastUpdate: moment().format(), ...payload };

    const response = await addDoc(clients, data);
    return response;
  } catch (error) {
    console.log("Referall Err:", error)
  }
}

export const showSuccssMsg = (msg) => {
  toast.success(msg, { autoClose: 2000 });
};

export const showErrMsg = (msg) => {
  toast.error(msg, { autoClose: 2000 });
};
// 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
const GITHUB_TOKEN = "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"; // internal only
const OWNER = "flipflopinfotech";
const REPO = "company-website-v2";
const BRANCH = "local-dev";


export const uploadToGithub = async ({ file, path }) => {
  const base64 = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result.split(",")[1]);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
  // 1️⃣ check if file already exists → get sha
  const getFileSha = async () => {
    const res = await fetch(
      `https://api.github.com/repos/${OWNER}/${REPO}/contents/${path}?ref=${BRANCH}`,
      {
        headers: {
          Authorization: `Bearer ${GITHUB_TOKEN}`,
          Accept: "application/vnd.github+json",
        },
      }
    );

    if (res.status === 404) return null;
    const data = await res.json();
    return data.sha;
  };

  const sha = await getFileSha();

  // 2️⃣ build request body
  const body = {
    message: `Upload ${path}`,
    content: base64,
    branch: BRANCH,
    ...(sha && { sha }), // 👈 THIS FIXES 409
  };

  // 3️⃣ upload / overwrite
  return fetch(
    `https://api.github.com/repos/${OWNER}/${REPO}/contents/${path}`,
    {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${GITHUB_TOKEN}`,
        Accept: "application/vnd.github+json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    }
  );
};

